import getUserInterfaceSettingsQuery from "/public/graphQl/queries/getUserInterfaceSettings";

export const getColumns = async ({dispatch, commit, rootGetters}, id) => {
    let setingsData;
    const organizationId = rootGetters['app/getSelectedOrganization'].id;

    const variables = {
        organizationId,
        name: 'addressHistoryColumns'
    }

    try {
        // commit('app/toggleLoading', null, {root: true});
        setingsData = await dispatch('app/request', {
            type: 'query',
            gql: getUserInterfaceSettingsQuery,
            variables
        }, {root: true});
    } catch (error) {
        return error;
    } finally {
        // commit('app/toggleLoading', null, {root: true});
    }

    if (setingsData.message) {
        throw setingsData.message;
    }

    if (setingsData.errors) {
        throw setingsData.errors;
    }

    const {
        data: {getUserInterfaceSettings},
    } = setingsData;
    const menu = getUserInterfaceSettings.entities ? getUserInterfaceSettings.entities : []
    if (!menu.length) {
        commit('setColumns', menu)
    } else {
        commit('setColumns', JSON.parse(menu))
    }

    return getUserInterfaceSettings;
};
